// Internal Endpoints for BFF

export const SEARCH_SUGGESTIONS = '/api/search/suggestions';
export const LOCATIONS = '/api/locations';
export const LOCATIONS_INFO_V2 = '/api/locations/v2';
export const SAVED_LISTS = '/api/savedLists';
export const SAVED_LIST_DUPLICATE = '/api/savedLists/duplicateList';
export const DEALER_CUSTOMERS = '/api/dealer-customers/{customerNumber}';
export const DEALER_SEARCH = '/api/dealer-search';
export const DEALER_SEARCH_CUSTOMER = '/api/dealer-search/{customerNumber}';
export const EQUIPMENT_SEARCH_SUGGESTIONS = '/api/equipment/search-suggestions';
export const PLACES = '/api/places';
export const EQUIPMENT_SEARCH = '/api/me/equipment-suggestions';
export const DEALER_INFO = '/api/dealer-info';
export const USER_RESET_SESSION = '/api/user-reset-session';
export const PRICE_AND_AVAILABILITY = '/api/price-and-availability';
export const CART_DETAILS = '/api/cart';
export const CART_ORDER_TOTALS = '/api/cart/order-totals';
export const EXPORT_ORDER = '/api/order/{orderId}/export';
export const TAX_AND_FREIGHT_API = '/api/tax-and-freight/{orderId}';
export const GET_ATTACHMENT_SUGGESTIONS_API = '/api/get-attachment/suggestions';
export const GET_ATTACHMENT_PRODUCTS_API = '/api/get-attachment/products';
export const GET_ATTACHMENT_EQUIPMENT_FAMILIES_API =
  '/api/get-attachment/equipment-families';
export const BEST_SELLER_API = '/api/product/best-seller';
export const LD_FEATURE_FLAG = '/api/flag';
